import { render, staticRenderFns } from "./switch-option.vue?vue&type=template&id=099e67ab&scoped=true&"
import script from "./switch-option.vue?vue&type=script&lang=js&"
export * from "./switch-option.vue?vue&type=script&lang=js&"
import style0 from "./switch-option.vue?vue&type=style&index=0&id=099e67ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099e67ab",
  null
  
)

export default component.exports